export default "__VITE_ASSET__SmqqL0xN__"